import { motion } from "framer-motion";
import { DownloadButton, StoreButtons } from "./DownloadButtons";

export const FinalCTA = () => {
  return (
    <section className="bg-white px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative mx-auto max-w-6xl overflow-hidden rounded-[2rem] bg-ink px-6 py-16 text-center sm:px-10 lg:rounded-[2.5rem] lg:py-24"
      >
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute left-1/2 top-[-20%] h-[400px] w-[600px] -translate-x-1/2 rounded-full bg-brand/30 blur-[120px]" />
          <div className="absolute inset-0 grain opacity-[0.04]" />
        </div>

        <div className="relative">
          <h2 className="mx-auto max-w-3xl font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl lg:text-5xl">
            Ton prochain client pourrait déjà être dans ton{" "}
            <span className="text-brand">carnet d'adresses.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-lg text-white/60">
            Ne laisse plus les besoins que tu ne peux pas traiter se perdre. Télécharge
            Leadzi CHR et commence à valoriser tes opportunités commerciales.
          </p>

          <div className="mt-9 flex justify-center">
            <DownloadButton testId="final-cta-download-button" className="px-8 py-4 text-base" />
          </div>
          <div className="mt-6 flex justify-center">
            <StoreButtons light />
          </div>
        </div>
      </motion.div>
    </section>
  );
};
